"use client"

import { useState, useEffect } from "react"
import { Button, Card } from "react-bootstrap"

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [showInstallPrompt, setShowInstallPrompt] = useState(false)
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    // Check if app is already installed
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
      setIsInstalled(true)
      return
    }

    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault()
      // Save the event so it can be triggered later
      setDeferredPrompt(e)
      // Show the install prompt
      setShowInstallPrompt(true)
    }

    // Listen for the app being installed
    const handleAppInstalled = () => {
      console.log("PWA was installed")
      setIsInstalled(true)
      setShowInstallPrompt(false)
      setDeferredPrompt(null)
    }

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt)
    window.addEventListener("appinstalled", handleAppInstalled)

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt)
      window.removeEventListener("appinstalled", handleAppInstalled)
    }
  }, [])

  const handleInstallClick = async () => {
    if (!deferredPrompt) return

    // Show the install prompt
    deferredPrompt.prompt()

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice

    if (outcome === "accepted") {
      console.log("User accepted the install prompt")
    } else {
      console.log("User dismissed the install prompt")
    }

    // Clear the deferredPrompt
    setDeferredPrompt(null)
    setShowInstallPrompt(false)
  }

  const handleDismiss = () => {
    setShowInstallPrompt(false)
    // Remember user dismissed the prompt (optional)
    localStorage.setItem("pwa-install-dismissed", "true")
  }

  // Don't show if already installed or user previously dismissed
  if (isInstalled || !showInstallPrompt || localStorage.getItem("pwa-install-dismissed")) {
    return null
  }

  return (
    <Card className="mb-3 border-success">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="me-3">
              <i className="fas fa-mobile-alt fa-2x text-success"></i>
            </div>
            <div>
              <h6 className="mb-1">Install AgroPlanner App</h6>
              <small className="text-muted">
                Get faster access and work offline by installing our app on your device
              </small>
            </div>
          </div>
          <div className="d-flex gap-2">
            <Button variant="outline-secondary" size="sm" onClick={handleDismiss}>
              Not Now
            </Button>
            <Button variant="success" size="sm" onClick={handleInstallClick}>
              <i className="fas fa-download me-1"></i>
              Install
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default PWAInstallPrompt
